<script>
import cloneDeep from "lodash/cloneDeep";
import moment from "moment";
import PagenationContainer from "@/components/common/PagenationContainer.vue";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export default {
  components: {
    PagenationContainer
  },
  data() {
    return {
      userData: {
        staffId: undefined,
        name: undefined,
        phone: undefined,
        role: undefined,
        gender: undefined
      },
      searchData: {
        recordType: undefined
      },
      dateRange: undefined,
      pageCount: 0,
      activePage: 1,
      tableData: [],
      searchArray: [
        {
          label: "操作人",
          keyName: "doctorName",
          type: "text",
          value: ""
        },
        {
          label: "记录类型：",
          keyName: "recordType",
          type: "radio",
          value: "",
          children: [
            {
              label: "全部",
              keyName: ""
            },
            {
              label: "出售",
              keyName: "PURCHASE"
            },
            {
              label: "退款",
              keyName: "REFUND"
            }
          ]
        }
      ],
      buttonArray: [
        {
          text: "最近一周",
          key: "week"
        },
        {
          text: "最近30天",
          key: "month"
        },
        {
          text: "最近90天",
          key: "ninety"
        }
      ],
      exportSalesData: false,
      exportForm: {
        dataRange: []
      },
      exporting: false,
      exportXls: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  created() {
    this.dateRange = [];
    const time = this.$route.params.time;
      console.log("time:" + time)
      if (time.length == 7) {
        this.dateRange.push(time + "-01");
        const times = time.split("-");
        const lastDate = new Date(times[0], times[1], 0);
        this.dateRange.push(moment(lastDate).format("YYYY-MM-DD"));
      } else {
        this.dateRange.push(time + " 00:00:00");
        this.dateRange.push(time + " 23:59:59");
      }
    this.loadData();
  },
  methods: {
    getQueryParam() {
      let params = {}
      for (let key in this.searchData) {
        if (this.searchData[key]) {
          params[key] = this.searchData[key];
        }
      }
      if (this.dateRange && this.dateRange[0]) {
        params.start = this.dateRange[0] + " 00:00:00";
      }
      if (this.dateRange && this.dateRange[1]) {
        params.end = this.dateRange[1] + " 23:59:59";
      }
      const stationId = this.$route.params.stationId;
      params.stationId = stationId;
      return params
    },
    async loadData() {
      let params = this.getQueryParam()
      params.page = this.activePage - 1
      params.size = 20
      params.sort = "createdAt,DESC"
      
      const result = await this.$http.GetStationSalesDetails(
        params
      );
      if (result) {
        this.tableData = result.content;
        this.pageCount = result.totalPages;
        this.exportXls = [['机构名称', '日期', '患者姓名', '手机号', '疗程/单次', '单价', '数量', '记录类型', '操作人']];
        this.tableData.forEach((item, index) => {
          console.log("----------------------------")
          console.log(item)
          this.exportXls.push([
            item.stationName, this.timeForamter(item), item.patientName, item.patientPhone, 
            this.singleFormater(item), item.unitPrice, item.quantity, this.recordTypeFormater(item), item.doctorName]);
        });
      }
    },
    onExport() {
      try {
        // console.log(this.exportXls)
        const worksheet = XLSX.utils.aoa_to_sheet(this.exportXls);
        // const worksheet = XLSX.utils.json_to_sheet(this.exportXls);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        const wbout = XLSX.write(workbook, { bookType: 'xlsx', bookShelf: 'Sheet1', type: 'array' });
        const blob = new Blob([wbout], { type: 'application/vnd.openxmlformats - officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'export.xlsx');
      } catch (e) {
        console.error('获取数据或导出Excel出错:', e);
      }
    },
    async onExportAll() {
      if (this.exporting) {
        return;
      }
      if (this.totalElements > 3000) {
        this.$message.warning("导出的数据过多，请调整导出条件！")
        return;
      }
      this.exporting = true
      let params = this.getQueryParam()
      const result = await this.$http.GetStationSalesDetailsExport(
        params
      );
      const link = document.createElement("a");
      const blob = new Blob([result], {
          type: "application/vnd.ms-excel"
      });
      link.style.display = "none";
      link.href = URL.createObjectURL(blob);
      link.setAttribute("download", `销售数据.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.exporting = false;
    },
    onSearch(data) {
      this.activePage = 1;
      this.loadData();
    },
    onExport() {
      try {
        // console.log(this.exportXls)
        const worksheet = XLSX.utils.aoa_to_sheet(this.exportXls);
        // const worksheet = XLSX.utils.json_to_sheet(this.exportXls);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        const wbout = XLSX.write(workbook, { bookType: 'xlsx', bookShelf: 'Sheet1', type: 'array' });
        const blob = new Blob([wbout], { type: 'application/vnd.openxmlformats - officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'export.xlsx');
      } catch (e) {
        console.error('获取数据或导出Excel出错:', e);
      }
    },
    onSearchChange(data) {
      this.searchData = data;
    },
    handleCurrentChange(val) {
      this.activePage = val;
      this.loadData();
    },
    onOperationClick(row, key) {
      switch (key) {
        case "month":
          this.dateRange = [
            moment()
              .subtract(30, "days")
              .format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD")
          ];
          break;
        case "ninety":
          this.dateRange = [
            moment()
              .subtract(90, "days")
              .format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD")
          ];
          break;
        case "week":
          this.dateRange = [
            moment()
              .subtract(6, "days")
              .format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD")
          ];
          break;
      }
    },
    timeForamter(row) {
      console.log(row.createdAt);
      return moment(row.createdAt).format('YYYY-MM-DD HH:mm:ss');
    },
    singleFormater(row){
      return row.singleFlag ? "单次" : "疗程"
    },
    recordTypeFormater(row) {
      return row.recordType == 'REFUND' ? "退款" : (row.unitPrice == 0 && row.complimentary ? "赠送" : "出售");
    },
    async confirmExport() {
      if (this.exportForm.dataRange[0] && this.exportForm.dataRange[1]) {
        const params = {
          start: this.exportForm.dataRange[0],
          end: this.exportForm.dataRange[1]
        };
        const result = await this.$http.getExportSalesData(
          this.$route.params.accountId,
          params
        );
        console.log("result", result);
        const link = document.createElement("a");
        const blob = new Blob([result], {
          type: "application/vnd.ms-excel"
        });
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", `销售数据.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.exportSalesData = false;
      } else {
        this.$message.warning("请先选择时间段！");
      }
    }
  }
};
</script>
<template>
  <div class="salesManagementDetail">
    <!-- <el-card class="box-card basicInfo" shadow="never">
      <div slot="header" class="clearfix">
        <span class="cardTitleText">基本信息</span>
      </div>
      <div class="text item">
        <el-row :gutter="24">
          <el-col :span="5">
            <div class="grid-content bg-purple">机构Id： {{userData.stationId}}</div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple">机构名称： {{userData.stationName}}</div>
          </el-col>
          <el-col :span="5">
            <div class="grid-content bg-purple">地址： {{userData.location}}</div>
          </el-col>
        </el-row>
      </div>
    </el-card>-->
    <el-card class="box-card withoutBorderBottom" shadow="never">
      <el-row :gutter="24">
        <el-col :span="24">
          <div class="TextGroup">
            <div class="dataSearch">
              <span>销售疗程时间筛选：</span>
              <el-date-picker
                v-model="dateRange"
                @keyup.enter.native="onSearch"
                size="medium"
                class="dateRange"
                type="daterange"
                range-separator="至"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
              <textButtonGroup
                class="dataButton"
                :buttonArray="buttonArray"
                @onOperationClick="onOperationClick"
                @keyup.enter.native="onSearch"
              />
              <el-button type="primary" class="searchButton" @click="onSearch" size="mini">搜索</el-button>
              <el-button type="primary" class="searchButton" size="mini" @click="onExport">导出当前页</el-button>
              <el-button type="primary" class="searchButton" size="mini"  @click="onExportAll">导出全部</el-button>
              <!-- <el-button class="searchButton" type="primary" @click="onExport" size="mini">导出</el-button> -->
            </div>
          </div>
          <searchFormNew
            class="searchForm"
            @onChange="onSearchChange"
            :searchItemArray="searchArray"
            @onSearch="onSearch"
          />
        </el-col>
        <!--<el-col :span="6">
          <div class="searchLocation">
            <div>
              <div class="saleNumberTitle">销售总疗程</div>
              <div class="saleNumber">{{userData.totalSalesCourse}}</div>
            </div>
            <div class="line"></div>
            <div>
              <div class="saleNumberTitle">销售总金额</div>
              <div class="saleNumber">{{userData.totalSalesAmount}}</div>
            </div>
          </div>
        </el-col>-->
      </el-row>
      <el-table
        :data="tableData"
        class="AgencyRangeTable"
        :header-cell-style="{ 'padding-left': '5px',color: 'rgba(0,0,0,0.65)','font-size': '14px', 'background-color': '#fafafa !important'}"
        :cell-style="{'padding-left': '5px'}"
      >
        <el-table-column prop="stationName" align="left" label="机构名称" min-width="80"></el-table-column>
        <el-table-column prop="createdAt" align="left" label="日期" min-width="65" :formatter="timeForamter"></el-table-column>
        <el-table-column prop="patientName" align="left" label="患者姓名" min-width="60"></el-table-column>
        <el-table-column prop="patientPhone" align="left" label="手机号" min-width="60"></el-table-column>
        <el-table-column prop="single" align="left" label="疗程/单次" min-width="60" :formatter="singleFormater"></el-table-column>
        <el-table-column prop="unitPrice" align="left" label="单价" min-width="40"></el-table-column>
        <el-table-column prop="quantity" align="left" label="数量" min-width="40"></el-table-column>
        <el-table-column prop="recordType" align="left" label="记录类型" min-width="40" :formatter="recordTypeFormater"></el-table-column>
        <el-table-column prop="doctorName" align="left" label="操作人" min-width="40"></el-table-column>
      </el-table>
      <PagenationContainer v-if="pageCount > 1">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="activePage"
          :page-count="pageCount"
          layout="prev, pager, next, jumper"
        ></el-pagination>
      </PagenationContainer>
    </el-card>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.salesManagementDetail {
  background-color: #f5f6f7;

  .basicInfo {
    margin: 15px 0;

    .grid-content {
      padding: 15px 0px;
      border-radius: 4px;
    }

    .el-pagination {
      text-align: center;
      margin-top: 10px;
    }

    .text {
      font-size: 14px;
      padding-top: 0px;
    }
    .genderStyle {
      // width: 11px;
      height: 17.5px;
      margin-bottom: -2px;
    }
    .item {
      margin-bottom: 18px;

      .checkBoxLabel {
        color: #303133;

        .el-checkbox__input.is-disabled + span.el-checkbox__label {
          color: #303133;
        }
      }
    }

    .clearfix:before,
    .clearfix:after {
      display: table;
      content: "";
    }

    .clearfix:after {
      clear: both;
    }

    .cardTitleText {
      font-size: 16px;
      font-weight: bold;
    }
  }

  .TextGroup {
    display: flex;
    font-size: 14px;
    font-weight: 400;
    color: #606266;
    .dateRange {
      width: 250px;

      .el-range-editor--mini.el-input__inner {
        height: 32px;
      }

      .el-range-editor.is-active,
      .el-range-editor.is-active:hover {
        border-color: #00c1de;
      }

      .el-date-table td.today span {
        color: #00c1de;
      }
    }

    .dataButton {
      margin-left: 10px;
      margin-right: 15px;
      display: inline-block;
    }
    .searchButton {
      border-color: #00c1de;
      background-color: #00c1de;
    }
  }
  .searchLocation {
    display: flex;
    text-align: center;
    .line {
      width: 1px;
      height: 40px;
      background-color: #e4e8eb;
      margin-left: 25px;
      margin-right: 25px;
    }
    .saleNumberTitle {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.45);
      line-height: 22px;
    }
    .saleNumber {
      font-size: 25px;
      font-family: HelveticaNeue;
      color: rgba(0, 0, 0, 0.85);
      line-height: 38px;
    }
  }
  .AgencyRangeTable {
    width: 98%;
    margin: auto;

    .el-table__body tr:hover > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }

    .el-table__body tr.current-row > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }
  }

  .withoutBorderBottom {
    border-bottom: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/salesManagement/stationSalesDetail.vue